import React from "react";

const Services = () => {
  // services details
  // const services = [
  //   {
  //     name: "Graphic Design",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-palette",
  //   },
  //   {
  //     name: "Web Design",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-desktop",
  //   },
  //   {
  //     name: "UI/UX Design",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-pencil-ruler",
  //   },
  //   {
  //     name: "App Design & Develop",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-paint-brush",
  //   },
  //   {
  //     name: "Business Analysis",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-chart-area",
  //   },
  //   {
  //     name: "SEO Marketing",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
  //     icon: "fas fa-bullhorn",
  //   },
  // ];

  const services = [
  {
    name: "Financial Strategy & FP&A",
    desc: "Driving data-informed decisions through rigorous financial planning, forecasting, and analysis to align capital allocation with long-term business objectives.",
    icon: "fas fa-chart-line",
  },
  {
    name: "M&A & Turnarounds",
    desc: "Leading acquisitions, integrations, and complex turnarounds — identifying value, managing risk, and executing transitions that unlock sustainable growth.",
    icon: "fas fa-handshake",
  },
  {
    name: "Capital & Treasury Management",
    desc: "Optimizing capital structure, liquidity, and funding strategies to ensure financial resilience and fuel operational and strategic growth initiatives.",
    icon: "fas fa-university",
  },
  {
    name: "Operational Excellence",
    desc: "Implementing lean systems, scalable infrastructure, and process improvements that reduce friction, cut costs, and position organizations to thrive under complexity.",
    icon: "fas fa-cogs",
  },
  {
    name: "Board & Investor Relations",
    desc: "Building trust and transparency with boards, investors, and stakeholders through clear communication, governance, and alignment on value creation priorities.",
    icon: "fas fa-users",
  },
  {
    name: "ERP & Digital Transformation",
    desc: "Spearheading ERP, SaaS, and digital initiatives that modernize operations, improve data visibility, and create competitive advantage across the enterprise.",
    icon: "fas fa-digital-tachograph",
  },
];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
